var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{ref:"input",staticClass:"form-control new-design address-icon auto",attrs:{"type":"text","id":_vm.id,"required":_vm.required,"placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":_vm.handleInput,"change":_vm.handleInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }